import { z } from 'zod'
import {
  ChangeId,
  EndDate,
  Id,
  IsActive,
  IsActual,
  NextId,
  ObjectId,
  ObjectUuid,
  OperationTypeId,
  PrevId,
  StartDate,
  UpdateDate,
} from './common-schemas'
import { GarItem } from './gar-item'

export namespace CarPlace {
  export interface Data {
    /** @description Unique record identifier. Key field */
    readonly id: number

    /** @description Global unique object identifier */
    readonly objectId: number

    /** @description Global unique object identifier (UUID) */
    readonly objectGuid: string

    /** @description Identifier of the changing transaction */
    readonly changeId: number

    /** @description Car place number */
    readonly number: string

    /** @description Record action status */
    readonly operationTypeId: number

    /** @description Identifier of the record linking to the previous historical record */
    readonly prevId?: number

    /** @description Identifier of the record linking to the subsequent historical record */
    readonly nextId?: number

    /** @description Record entry (update) date */
    readonly updateDate: Date

    /** @description Record validity start */
    readonly startDate: Date

    /** @description Record validity end */
    readonly endDate: Date

    /** @description FIAS address object relevance status */
    readonly isActual: boolean

    /** @description Active address object indicator */
    readonly isActive: boolean
  }
}

/** @description Information about car place */
export class CarPlace extends GarItem<'CarPlace', CarPlace.Data> {
  static readonly SCHEMA: GarItem.Schema<CarPlace.Data> = z
    .strictObject({
      ID: Id,

      OBJECTID: ObjectId,

      OBJECTGUID: ObjectUuid,

      CHANGEID: ChangeId,

      NUMBER: z.string().describe('Car place number'),

      OPERTYPEID: OperationTypeId,

      PREVID: PrevId.optional(),

      NEXTID: NextId.optional(),

      UPDATEDATE: UpdateDate,

      STARTDATE: StartDate,

      ENDDATE: EndDate,

      ISACTUAL: IsActual,

      ISACTIVE: IsActive,
    })
    .transform<CarPlace.Data>(attributes => ({
      id: attributes.ID,
      objectId: attributes.OBJECTID,
      objectGuid: attributes.OBJECTGUID,
      changeId: attributes.CHANGEID,
      number: attributes.NUMBER,
      operationTypeId: attributes.OPERTYPEID,
      prevId: attributes.PREVID,
      nextId: attributes.NEXTID,
      updateDate: attributes.UPDATEDATE,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
      isActual: attributes.ISACTUAL,
      isActive: attributes.ISACTIVE,
    }))

  readonly type = 'CarPlace'

  protected get schema() {
    return CarPlace.SCHEMA
  }
}
